import React, { useEffect, useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import SEO from '../components/seo';
import Layout from '../components/layout';
import Contact from '../components/Contact/Contact';
import Afiliate from '../components/Afiliate/Afiliate';
import Subscribe from '../components/Subscribe/Subscribe';
import Simulador from '../components/Simulador/Investor';
import InversionAMedida from '../components/InversionAMedida/InversionAMedida';
import NonStretchedImage from '../components/NonStretchedImage/NonStretchedImage'

const styles = {
  borderRadius: '54% 0% 50% 50% / 0% 54% 4% 4%',
  backgroundImage: 'linear-gradient(to bottom, hsla(0, 0%, 100%, 0), hsl(225, 33%, 98%) 59%, hsl(228, 33%, 97%))',
};

const InversinistasPage = () => {
  const [top, setTop] = useState('0px');

  const result = useStaticQuery(
    graphql`
      {
        file(relativePath: { eq: "afiliate-investor.png" }) {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
              presentationWidth
            }
          }
        }
      }
    `
  );

  useEffect(() => {
    if (matchMedia("(min-width: 420px)").matches) {
      setTop('-80px');
    }
  }, []);


  return (
    <Layout>
    <SEO title="Inversionistas" />
    <section style={{...styles, top}} className="relative pt-0 md:pt-0 min-h-screen md:h-screen">
      <div className="max-w-7xl min-h-screen mx-auto justify-center flex flex-col items-center mt-24 md:mt-0 md:flex-row">
        <div className="px-5 md:my-0 md:max-w-xl md:w-1/2">
          <h1 className="text-3xl py-4 font-thin leading-normal text-gray-700 md:text-5xl">
            Invierte en el{' '}
            <span className="text-red-100">capital de trabajo</span> de empresas
            mexicanas
          </h1>
          <p className="text-gray-700 text-xl font-thin">
            Diversifica tu inversión en facturas de empresas triple A. Obtén altos
            rendimientos a corto plazo y apoya a la economía mexicana.
          </p>
        </div>
        <Simulador />
      </div>
    </section>
    <section className="px-4 pb-20 mt-24 min-h-screen">
      <Afiliate />
    </section>
    <section className="mx-auto relative min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div
          style={{ top: '50%', transform: 'translateY(-50%)' }}
          className="p-8 mx-4 max-w-xl absolute z-10 bg-white border-l-8 border-red-100 md:max-w-3xl md:p-16"
        >
          <h2 className="text-gray-700 mb-4 text-3xl md:text-4xl">Ofrecemos las tasas de rendimiento más altas</h2>
          <p className="text-gray-700 md:text-xl">Diseñamos una plataforma donde personas físicas y morales pueden adquirir <strong>derechos de cobro</strong> y diversificar sus ingresos, mediante una inversión segura, protegida, en línea.</p>
        </div>
      </div>
      <NonStretchedImage
        className="absolute z-0 right-0 h-screen w-full object-contain"
        fluid={result.file.childImageSharp.fluid}
        alt="Afiliate a Fondimex"
      />
    </section>
    <section
      className="max-w-7xl mx-auto relative mb-20 min-h-screen py-10 md:py-0 md:flex md:flex-col md:justify-center">
      <h2 className="text-gray-700 px-4 mb-12 text-3xl md:text-5xl">Encuentra la inversión a tu medida</h2>
      <InversionAMedida />
    </section>
    <Contact type="inversionista" />
    <Subscribe />
  </Layout>
  )
};

export default InversinistasPage;
